import { useParams } from "react-router-dom";
import ExtendContact from "./ExtendContact";
import { Box } from "@mui/material";
export const ShowContact = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendContact row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
